// Copyright (c) Facebook, Inc. and its affiliates.
import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import { withStyles } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const styles = theme => ({
    gridContainer: {
        marginTop: '0.25rem',
    },
    divider: {
        backgroundColor: theme.palette.primary.main,
        height: '0.25em',
    },
});

class CustomDivider extends React.Component {
    render() {

        const { classes } = this.props;
        let lgSize = 1;
        if (this.props.lgSize) {
            lgSize = this.props.lgSize
        }
        return (
            <Grid
                container
                className={classes.gridContainer}
                justify="center"
                spacing={16}
            >
                <Grid item xs={4} sm={1} lg={lgSize}>
                    <Grid
                        container
                        justify="center"
                    >
                        <Grid item xs={8} lg={6}>
                            <Divider
                                className={classes.divider}
                            />
                        </Grid>
                    </Grid>

                </Grid>
            </Grid>
        )
    }

}

export default withStyles(styles)(CustomDivider);
